import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Modal, Backdrop, Fade, Grid } from '@material-ui/core';
import clsx from 'clsx';

import RenderFieldBasedOnType from '../../RenderFieldsBasedOnType';
import DataTable from '../DataTable/DataTable';
import useStyles from './style';

const SupplementalInfoViewer = (props) => {
  const { blockState, block, onChangeSupplementalInfo, isEditable } = props;

  const config = block?.config?.[0] || {};
  const formDataElements = config?.formDataElements || [];
  const tableDataElements = config?.TableDataElements || [];
  const classes = useStyles();
  const { chartUniqueId, chartData } = props.data

  const [isYesSelected, setIsYesSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);

  const [editingIndex, setEditingIndex] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleCloseModel = () => {
    // props.onEditModeChange && props.onEditModeChange(false);
    setOpen(false);
  };

  const handleYesNoSelection = (isYes) => setIsYesSelected(isYes);
  const handlePageChange = (event, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isLoading = props.formData?.[`${block?.dataElement}_loading`] ||
    props.formData?.[`${chartUniqueId}_supplementalInfo_loading`] ||
    false;

  useEffect(() => {
    const data = blockState?.[block?.dataElement] || [];
    setTableData(data);
    if (data && data.length > 0) setIsYesSelected(true);
  }, [blockState, block?.dataElement]);

  // Convert value based on dataType
  const convertValue = (value, dataType) => {
    if (value === null || value === undefined || value === '') {
      return dataType === 'number' ? 0 : '';
    }
    if (dataType === 'number') {
      const numValue = parseFloat(value);
      return isNaN(numValue) ? 0 : numValue;
    }
    return String(value);
  };

  const handleOnFieldChange = (name, value, _type, _uiFieldType, _header, _valueObj) => {
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === 'dataType' && prev.value !== undefined) {
        updated.value = convertValue(prev.value, value);
      }
      return updated;
    });
  };

  // const handleSave = () => {
  //   const newDataPoint = {};
  //   formDataElements.forEach((element) => {
  //     const val = formData[element.value];
  //     if (val !== undefined && val !== null) {
  //       if (element.value === 'value') {
  //         const dataType = formData.dataType || 'string';
  //         newDataPoint[element.value] = convertValue(val, dataType);
  //       } else {
  //         newDataPoint[element.value] = val;
  //       }
  //     }
  //   });

  //   const currentData = blockState?.[block?.dataElement] || [];
  //   const updatedData = [...currentData, newDataPoint];



  //   if (props.match?.params?.id && props.onEditModeChange) {
  //     console.log('props**SupplementalInfoViewer', props.match?.params?.id, props.onEditModeChange)
  //     props.onEditModeChange(true);
  //   }

  //   // console.log('props**SupplementalInfoViewer**2', props)

  //   if (onChangeSupplementalInfo) {
  //     onChangeSupplementalInfo(block?.dataElement, updatedData);
  //   }



  //   setFormData({});
  //   handleCloseModel();
  // };

  const handleSave = () => {
    const newDataPoint = {};
    formDataElements.forEach((element) => {
      const val = formData[element.value];
      if (val !== undefined && val !== null) {
        if (element.value === 'value') {
          const dataType = formData.dataType || 'string';
          newDataPoint[element.value] = convertValue(val, dataType);
        } else {
          newDataPoint[element.value] = val;
        }
      }
    });

    const currentData = blockState?.[block?.dataElement] || [];
    let updatedData;
    
    if (editingIndex !== null) {
      // Update existing row
      updatedData = [...currentData];
      updatedData[editingIndex] = newDataPoint;
    } else {
      // Add new row
      updatedData = [...currentData, newDataPoint];
    }

    if (props.match?.params?.id && props.onEditModeChange) {
      console.log('props**SupplementalInfoViewer', props.match?.params?.id, props.onEditModeChange)
      props.onEditModeChange(true);
    }

    if (onChangeSupplementalInfo) {
      onChangeSupplementalInfo(block?.dataElement, updatedData);
    }

    setFormData({});
    setEditingIndex(null); // Reset editing state
    handleCloseModel();
  };
  
  const handleActionClick = (_row, index) => {
    const currentData = blockState?.[block?.dataElement] || [];
    const updatedData = currentData.filter((_, i) => i !== index);
    if (onChangeSupplementalInfo) {
      onChangeSupplementalInfo(block?.dataElement, updatedData);
    }
    if (props.match?.params?.id && props.onEditModeChange) {
      props.onEditModeChange(true);
    }
  };

  const handleEditClick = (row, index) => {
    console.log('handleEditClick', row, index);
    setFormData(row);
    setEditingIndex(index);
    setOpen(true);
  };

  const handleDeleteClick = (row, index) => {
    console.log('handleDeleteClick', row, index);
  };
  return (
    <div className={classes.rootPadding}>
      <div className={classes.groupCol}>
        <div className={classes.titleRow}>
          <Typography className={classes.titleText}>{block.title}</Typography>

          <div className={classes.toggleWrap}>
            <div
              className={clsx(classes.toggleBtnLeft, isYesSelected && classes.toggleActive)}
              onClick={() => handleYesNoSelection(true)}
            >
              <Typography className={clsx(classes.toggleLabel, isYesSelected && classes.toggleLabelActive)}>
                Yes
              </Typography>
            </div>
            <div
              className={clsx(classes.toggleBtnRight, !isYesSelected && classes.toggleActive)}
              onClick={() => handleYesNoSelection(false)}
            >
              <Typography className={clsx(classes.toggleLabel, !isYesSelected && classes.toggleLabelActive)}>
                No
              </Typography>
            </div>
          </div>
        </div>

        {isYesSelected && (
          <div className={classes.dataBlock}>
            <div>
              {/* <DataTable
                headers={tableDataElements}
                data={tableData}
                page={page}
                rowsPerPage={rowsPerPage}
                totalRecords={tableData.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                showPagination={false}
                actionColumn={true}
                onActionClick={handleActionClick}
                actionIcon="/media/createStepper/deleteContracts.svg"
              /> */}
              {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                  {props.loader}
                </div>
              ) : (
                <DataTable
                  headers={tableDataElements}
                  data={tableData}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  totalRecords={tableData.length}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                  showPagination={false}
                  actionColumn={isEditable} // Only show action column if editable
                  actionIcon={isEditable ? "/media/createStepper/deleteContracts.svg" : null}
                  onActionClick={isEditable ? (row, idx) => {
                    handleActionClick(row, idx);
                  } : null}
                  uniqueId={123}
                  showEditAction={isEditable}
                  onEditClick={isEditable ? (row, idx) => {
                    handleEditClick(row, idx);
                  } : null}
                  showDeleteAction={isEditable}
                  onDeleteClick={isEditable ? (row, idx) => {
                    handleActionClick(row, idx);
                  } : null}
                  cellStyle={{ borderLeft: 'none', borderTop: 'none' }}
                />
              )}
            </div>

            <div className={classes.addBtnRow}>
              <Button variant="contained" className={classes.addBtn} onClick={handleOpen} disabled={!isEditable} style={{ backgroundColor: isEditable ? '' : 'transparent', cursor: isEditable ? 'pointer' : 'not-allowed' }}>
                + Add Data
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleCloseModel}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <div className={`${classes.modalPaper} myScrollContainer`}>
            <div className={classes.modalHeader}>
              <Typography className={classes.modalHeaderTitle}> {editingIndex !== null ? 'Edit Data point' : 'Add Data point'}</Typography>
            </div>

            <div className={classes.modalForm}>
              {formDataElements?.length > 0 &&
                formDataElements.map((element, index) => (
                  <Grid item key={index} xs={element.xs ? element.xs : 12} className={classes.formItem}>
                    <Typography className={classes.formLabel}>{element.label}</Typography>
                    <RenderFieldBasedOnType
                      {...props}
                      classes={classes}
                      element={element}
                      onChange={handleOnFieldChange}
                      dataObj={formData}
                      options={element?.data?.options ? element.data.options : {}}
                      selectedStep={props.selectedStep}
                    />
                    <Typography className={classes.formHelper}>{element.helperText}</Typography>
                  </Grid>
                ))}
            </div>

            <div className={classes.modalFooter}>
              <Button variant="contained" size="small" className={classes.modalBtn} onClick={handleCloseModel}>
                Close
              </Button>
              <Button variant="contained" size="small" className={classes.modalBtnPrimary} onClick={handleSave}>
                {editingIndex !== null ? 'Update' : 'Add'}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default SupplementalInfoViewer;
